import { Typography } from "components/typography";
import { PsychologistProfile, UserWithNullableNames } from "core/types";
import { ChangeEvent } from "react";
import { useTranslation } from "react-i18next";
import { styled } from "styled-components";
import { type PhoneFieldChangeValue } from "components/phone-field";
import { useDemo } from "contexts/DemoContext";
import useMarketStrategy from "../../../strategies/market/useMarketStrategy";
import { possibleCombinations } from "./rowCombinations";

type Props = {
  user: UserWithNullableNames;
  nameValidation: { field: string; message: string }[];
  psychologist: Pick<PsychologistProfile, "hsa" | "phone">;
  onChange: (
    x: string,
  ) => (arg: PhoneFieldChangeValue | ChangeEvent<HTMLInputElement>) => void;
  onChangeUser: (user: UserWithNullableNames) => void;
  psychologistValidation: string[];
};

const UserData = ({
  user,
  nameValidation,
  psychologist,
  onChange,
  onChangeUser,
  psychologistValidation,
}: Props) => {
  const { t } = useTranslation();
  const demo = useDemo();
  const marketStrategy = useMarketStrategy();
  const rowStrategy = marketStrategy?.psychologist?.userData?.rows;
  const MarketSpecificRows = rowStrategy.map(
    (row: string) => possibleCombinations[row],
  );

  const handleChangeUserField =
    (field: string) => (e: ChangeEvent<HTMLInputElement>) => {
      const updatedUser = {
        ...user,
        [field]: e.target.value,
      };

      onChangeUser(updatedUser);
    };
  return (
    <>
      <Typography variant="h3" style={{ marginBottom: "10px" }} insensitive>
        {t("ACCOUNT_DETAILS")}
      </Typography>
      <Form>
        {MarketSpecificRows.map((MarketSpecificRow, key) => (
          <MarketSpecificRow
            key={key}
            user={user}
            psychologist={psychologist}
            onChange={onChange}
            onChangeUser={handleChangeUserField}
            validation={nameValidation}
            psychologistValidation={psychologistValidation}
            demo={demo}
          />
        ))}
      </Form>
    </>
  );
};

const Form = styled.div`
  display: grid;
  grid-auto-rows: 1fr;
  row-gap: 24px;

  & > div {
    display: grid;
    grid-template-columns: repeat(2, minmax(304px, 50%));
  }
`;

export default UserData;
